import { render, staticRenderFns } from "./App.vue?vue&type=template&id=799aad1a&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=799aad1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799aad1a",
  null
  
)

export default component.exports